import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { IAdminTask, TaskSubjectKind } from '../../api/admin';
import AdminGridLink from './AdminGridLink';
import { SUBJECT_PATH } from './taskOptions';

interface Props {
	task: IAdminTask;
	/** The page's own kind: tags of that kind are implied there, so they are not repeated. */
	hideKind?: TaskSubjectKind;
}

/** "KIND name, name" with each name linking to its detail page; nothing when the task is untagged. */
export default function TaskSubjectLinks({ task, hideKind }: Props) {
	if (!task.subject_kind || task.subject_kind === hideKind || task.subjects.length === 0) {
		return null;
	}
	const path = SUBJECT_PATH[task.subject_kind];
	return (
		<Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, minWidth: 0 }}>
			<Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', flexShrink: 0 }}>
				{task.subject_kind}
			</Typography>
			<Typography variant="body2" noWrap>
				{task.subjects.map((s, i) => (
					<React.Fragment key={s.id}>
						{i > 0 && ', '}
						<AdminGridLink to={`${path}/${s.id}`}>{s.name}</AdminGridLink>
					</React.Fragment>
				))}
			</Typography>
		</Box>
	);
}
